export default "__VITE_ASSET__BfKg3ah5__"